import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52eb7cae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between card-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Orders", -1))
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Export Manufacturing ")
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Cancellation helper ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Import file to cancel ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Import history ")
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Hold Orders helper ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Import file to hold ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Import history ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_17 = {
  key: 0,
  class: "fas fa-check text-success"
}
const _hoisted_18 = {
  key: 1,
  class: "fas fa-pencil-ruler text-primary"
}
const _hoisted_19 = {
  key: 2,
  class: "fas fa-times text-error"
}
const _hoisted_20 = { class: "ml-3 date-picker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_filter_table = _resolveComponent("filter-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_ImportFile = _resolveComponent("ImportFile")!
  const _component_HistoryDialog = _resolveComponent("HistoryDialog")!
  const _component_ImportHoldOrderFile = _resolveComponent("ImportHoldOrderFile")!
  const _component_HistoryHoldOrderDialog = _resolveComponent("HistoryHoldOrderDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                (_ctx.props.isAllowImportExport && !_ctx.props.isOrderExporter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_el_dropdown, null, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exportOrderTypes, (type) => {
                                return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: type.value,
                                  onClick: ($event: any) => (_ctx.showModalExport(type.value))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(`Export ${type.title}`), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "danger",
                            loading: _ctx.data.isExporting
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5,
                              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_arrow_down)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.allowUseCancellationHelper)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_el_dropdown, { class: "ml-2" }, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_dropdown_item, { onClick: _ctx.openImportFile }, {
                                default: _withCtx(() => [
                                  _hoisted_8
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_el_dropdown_item, { onClick: _ctx.openHistoryDialog }, {
                                default: _withCtx(() => [
                                  _hoisted_9
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            loading: _ctx.data.isExporting
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7,
                              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_arrow_down)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.allowUseCancellationHelper)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_el_dropdown, { class: "ml-2" }, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_dropdown_item, { onClick: _ctx.openImportHoldOrderFile }, {
                                default: _withCtx(() => [
                                  _hoisted_12
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_el_dropdown_item, { onClick: _ctx.openHistoryHoldOrderDialog }, {
                                default: _withCtx(() => [
                                  _hoisted_13
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            loading: _ctx.data.isExporting
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11,
                              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_arrow_down)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_14
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 24,
          class: "flex mt-3 item-center"
        }, {
          default: _withCtx(() => [
            (!_ctx.props.isOrderExporter)
              ? (_openBlock(), _createBlock(_component_filter_table, {
                  key: 0,
                  onOnFilterCallback: _ctx.onFilterCallback,
                  placeholder: "Search",
                  title: "Search by Full name, Email, Phone, Address1"
                }, null, 8, ["onOnFilterCallback"]))
              : _createCommentVNode("", true),
            (!_ctx.props.isOrderExporter)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 1,
                  style: {"width":"fit-content"},
                  modelValue: _ctx.orderName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderName) = $event)),
                  placeholder: "Order Name",
                  clearable: "",
                  onChange: _ctx.onOrderNameChange
                }, null, 8, ["modelValue", "onChange"]))
              : _createCommentVNode("", true),
            (!_ctx.props.isOrderExporter)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 2,
                  style: {"width":"fit-content"},
                  modelValue: _ctx.transactionId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.transactionId) = $event)),
                  clearable: "",
                  placeholder: "Transaction ID",
                  onChange: _ctx.onTransactionIdChange
                }, null, 8, ["modelValue", "onChange"]))
              : _createCommentVNode("", true),
            (!_ctx.props.isOrderExporter)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 3,
                  modelValue: _ctx.props.params.status,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.props.params.status) = $event)),
                  placeholder: "FFM Status",
                  clearable: "",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusListAgency, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        placeholder: "FFM Status",
                        label: item.label,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            type: _ctx.getOrderStatusColor(item.value),
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["type"])
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (!_ctx.props.isOrderExporter)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 4,
                  clearable: "",
                  modelValue: _ctx.props.params.source,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.props.params.source) = $event)),
                  placeholder: "Source"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
            { label: 'CSV', value: 'csv' },
            { label: 'API', value: 'API' },
          ], (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        placeholder: "Source",
                        label: item.label,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            type: "info",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (!_ctx.props.isOrderExporter)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 5,
                  modelValue: _ctx.props.params.addressValid,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.props.params.addressValid) = $event)),
                  placeholder: "Address",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listAddressStatus, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        placeholder: "Status",
                        label: item.label,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            type: _ctx.getAddressStatusColor(item.value),
                            effect: "dark",
                            class: "rounded",
                            size: "small",
                            title: _ctx.addressTitleMap.get(item.value)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.addressTitleMap.get(item.value)), 1)
                            ]),
                            _: 2
                          }, 1032, ["type", "title"])
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (!_ctx.props.isOrderExporter)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 6,
                  modelValue: _ctx.props.params.exportStatus,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.props.params.exportStatus) = $event)),
                  placeholder: "Export",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
            { label: 'Exported', value: 1 },
            { label: 'Not Export', value: 0 },
          ], (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        placeholder: "Status",
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (!_ctx.props.isOrderExporter)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 7,
                  modelValue: _ctx.props.params.sellerTeam,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.props.params.sellerTeam) = $event)),
                  placeholder: "Seller",
                  clearable: "",
                  remote: "",
                  "remote-show-suffix": "",
                  "remote-method": _ctx.getSellerTeamList,
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sellerTeams, (seller) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: seller.id,
                        label: `${seller.name}-${seller.manager?.email}`,
                        value: seller.id,
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createElementVNode("span", null, [
                              (seller.name)
                                ? (_openBlock(), _createElementBlock("b", _hoisted_15, _toDisplayString(seller.name), 1))
                                : _createCommentVNode("", true),
                              _hoisted_16
                            ]),
                            _createTextVNode(" " + _toDisplayString(seller.manager?.email), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "remote-method"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (!_ctx.props.isOrderExporter)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 24,
              class: "flex mb-3 item-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.props.params.isUseLattePayment,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.props.params.isUseLattePayment) = $event)),
                  placeholder: "Payment",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
            { label: 'LatteX Payment', value: true },
            { label: 'Seller Payment', value: false },
          ], (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            type: item.value ? 'primary' : 'info'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["type"])
                        ]),
                        _: 2
                      }, 1032, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.props.params.orderType,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.props.params.orderType) = $event)),
                  placeholder: "Type",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderTypes, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.props.params.store,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.props.params.store) = $event)),
                  placeholder: "Store",
                  clearable: "",
                  filterable: "",
                  remote: "",
                  "remote-show-suffix": "",
                  "remote-method": _ctx.getAllStoresSellers
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stores, (store) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: store.id,
                        label: store.appShopUrl,
                        value: store.id,
                        clearable: ""
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "remote-method"]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.props.params.catalogType,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.props.params.catalogType) = $event)),
                  placeholder: "Catalog Type",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogTypes, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.title,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.props.params.fulfillmentWarning,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.props.params.fulfillmentWarning) = $event)),
                  placeholder: "Error reason",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
            { label: 'Not enough cash', value: 'not_enough_cash' },
            { label: 'Not enough design', value: 'not_enough_design' },
            { label: 'Not found catalog', value: 'not_found_catalog' },
            { label: 'Area can not shipping', value: 'not_shipping_country' },
            {
              label: 'Base-cost or shipping not found',
              value: 'bc_or_shipping_zero',
            },
          ], (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.props.params.hireDesignStatus,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.props.params.hireDesignStatus) = $event)),
                  placeholder: "Hire design status",
                  clearable: "",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hireDesignStatus, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        placeholder: "Hire design status",
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_select, {
                  clearable: "",
                  modelValue: _ctx.props.params.designStatus,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.props.params.designStatus) = $event)),
                  placeholder: "Artwork"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
            { label: 'Completed', value: 2 },
            { label: 'Requested', value: 1 },
            { label: 'Incomplete', value: 0 },
          ], (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        placeholder: "Artwork",
                        label: item.label,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          (item.value === 2)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                            : _createCommentVNode("", true),
                          (item.value === 1)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                            : _createCommentVNode("", true),
                          (item.value === 0)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.props.params.requestSellerReasonCode,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.props.params.requestSellerReasonCode) = $event)),
                  placeholder: "Request seller",
                  filterable: "",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option_group, { label: "Requested" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.RequestSeller.REASONS, (reason) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: `${_ctx.RequestSellerStatusEnum.requested}-${reason.value}`,
                            label: reason.label,
                            value: `${_ctx.RequestSellerStatusEnum.requested}-${reason.value}`
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option_group, { label: "Updated" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.RequestSeller.REASONS, (reason) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: `${_ctx.RequestSellerStatusEnum.updated}-${reason.value}`,
                            label: reason.label,
                            value: `${_ctx.RequestSellerStatusEnum.updated}-${reason.value}`
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.data.daterange,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.data.daterange) = $event)),
            onChange: _ctx.onChangeDate,
            type: "daterange",
            "range-separator": "~",
            "start-placeholder": "From date",
            "end-placeholder": "To date",
            shortcuts: _ctx.shortcutsDatetimePicker,
            "unlink-panels": ""
          }, null, 8, ["modelValue", "onChange", "shortcuts"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ImportFile, { ref: "importFileDialog" }, null, 512),
    _createVNode(_component_HistoryDialog, { ref: "historyDialog" }, null, 512),
    _createVNode(_component_ImportHoldOrderFile, { ref: "importHoldOrderFileDialog" }, null, 512),
    _createVNode(_component_HistoryHoldOrderDialog, { ref: "historyHoldOrderDialog" }, null, 512)
  ], 64))
}